import { isString } from "lodash";
import * as funcParser from "./func";

/**
 * 校验条件模板
 * 正则表达式校验欠完善？
 * @param {string} template 条件模板
 */
export const validate = (template) => {
  if (!isString(template)) {
    return {
      success: false,
      errorMsg: `${template} 条件模板须为字符串`,
    };
  }

  return {
    success: true,
    errorMsg: "",
  };
};

/**
 * 解析条件模板 "${fieldId}.value.value === 'SMLH'" => { raw, event: { fieldId: [ eventName ] } }
 * 在处理函数 handleConditon 中对不存在的 fieldId 进行处理
 * @param {string} template 条件模板 "${fieldId}.value.value === 'SMLH'"
 * @return {object} { raw, event: { fieldId: [ eventName ] } }
 */
export const parse = (template, options = {}) => {
  const validateResult = validate(template);
  console.warn(validateResult.success, validateResult.errorMsg);

  // 目前只支持值变更
  const event = {};
  (template.match(/(\${([^}]*)})/g) || []).forEach((item) => {
    const fieldId = item.match(/(\${([^}]*)})/)[2];
    if (!event[fieldId]) event[fieldId] = ["change"];
  });

  return {
    event,
    handler: () => {
      let result = false;
      try {
        result = isString(template)
          ? funcParser.parse(template, options)()
          : template;
        result = !!result;
      } catch (err) {
        result = false;
      }

      return result;
    },
  };
};
